/* eslint-disable import/prefer-default-export */
export const apiUrl = '/.netlify/functions';
